import React, { useCallback } from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { history } from '../store/configureStore';

const PageHeader = () => {
    const onClickGoTo = useCallback(() => {
        history.push('/');
    }, []);

    return (
        <Grid.Column>
            <div className="logo">
                <Header as="h1" onClick={onClickGoTo}>
                    <span>Verizon</span>
                </Header>
            </div>
        </Grid.Column>
    );
};

export default PageHeader;
